<div class="job-completed-container">
  <header class="header-bar">
    <div class="header-title">Apply for a Job</div>
  </header>

  <section class="icon-section">
    <img src="/assets/images/slang-to-the-moon.png" alt="slang-to-the-moon" />
  </section>

  @if (carrierData) {
    <section class="success-message">
      <mat-icon svgIcon="checkbox-circle-line-green"></mat-icon>
      <div class="message-text">
        <span class="regular-text">Congratulations!<br /><br />You have successfully applied to<br /></span>
        <span class="bold-text">{{ carrierData?.companyName }}.</span>
      </div>
    </section>
  }

  <div class="spacer"></div>

  <footer class="footer-bar">
    <div class="button-container">
      <button class="close-button" (click)="navigateBackToProfile()">Close</button>
    </div>
  </footer>
</div>